module.exports = __webpack_public_path__ + "static/media/5.03c1b67d.svg";